<template>
  <div class="col-12">
    <section-title
      class="mt-3"
      content="Firmas del Proveedor"
      :has-line="true"
    />

    <row-message
      class="row-message"
      text="Si desea editar la información de los firmantes lo deberá realizar directamente en el perfil del proveedor."
      warning
    />
    <div class="pt-2">
      <div
        v-for="(row, index) of data"
        :key="`signaturesprovider-item-${index}`"
        class="result-table"
      >
        <div class="row py-2 mr-md-0">
          <div class="row pt-2 col-md-6 pl-4">
            <div class="col-md-6">
              <div class="color-gray-6 font-14">
                Nombre del Contacto Principal:
              </div>
              <div class="color-black font-16 bold">
                {{ row.signatoryName }}
              </div>
            </div>
            <div class="col-md-6">
              <div class="color-gray-6 font-14">Número de Teléfono</div>
              <div class="color-black font-16 bold">
                {{ row.phone | phone }}
              </div>
            </div>
          </div>
          <div class="row pt-2 col-md-6 pl-4">
            <div class="col-md-6">
              <div class="color-gray-6 font-14">Correo Electrónico:</div>
              <div class="color-black font-16 bold">
                {{ row.email }} / {{ row.userName }}
              </div>
            </div>
            <div class="col-md-2">
              <div class="color-gray-6 font-14">Rol:</div>
              <div class="color-black font-16 bold">
                {{ row.rol }}
              </div>
            </div>
            <div class="row pt-2 col-md-1 pl-4">
              <div class="col-md-4">
                <div class="color-black font-16 bold">
                  <validation-provider v-slot="{ errors }" rules="required">
                    <custom-radio-button
                      :ref="`primaryProviderSigner-${index}`"
                      v-model="row.isProvider"
                      custom-error-msg="Proveedor es requerido."
                      :error="errors[0]"
                      :is-disabled="false"
                      is-inline
                      :name="`Proveedorfirmante`"
                      :options="
                        providerSelected != null
                          ? [
                              {
                                label: 'Firmante?',
                                value:
                                  row.userId == providerSelected ? true : index,
                              },
                            ]
                          : [
                              {
                                label: '¿Firmante?',
                                value: index,
                              },
                            ]
                      "
                      @input="changePrimaryProvider($event, row)"
                    />
                  </validation-provider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SectionTitle from 'SectionTitle';
import RowMessage from '@/components/common/RowMessage.vue';
import {
  getSignaturesProvider as _getSignaturesProvider,
  getUserInformation as _getUserInformation,
} from '@/services/uspqrp/contract.api';
import CustomRadioButton from 'custom-radio';

export default {
  name: 'SignaturesProvider',
  components: {
    SectionTitle,
    RowMessage,
    CustomRadioButton,
  },
  async mounted() {
    await this.getSignaturesProvider();
  },
  data: () => ({
    data: [],
  }),
  props: {
    contractId: {
      type: Number,
      default: 0,
      required: false,
    },
    companyId: {
      type: Number,
      default: 0,
      required: false,
    },
    requestServiceTypeId: {
      type: Number,
      default: 0,
      required: false,
    },
    providerSelected: {
      type: String,
      default: () => null,
      required: false,
    },
  },
  methods: {
    async getSignaturesProvider() {
      this.data = (
        await _getSignaturesProvider(this.companyId, this.contractId)
      ).data;

      const signaturesWithUserNames = await Promise.all(
        this.data.map(async (item) => {
          const rs = await _getUserInformation(item.userId);
          return {
            ...item,
            userName: rs.data.userName,
          };
        })
      );

      this.data = signaturesWithUserNames;
    },
    changePrimaryProvider(_event, row) {
      const newSignature = {
        signatoryname: row.signatoryName,
        contractid: this.contractId,
        relationTypeId: null,
        email: row.email,
        phone: row.phone,
        userid: row.userId,
        isPrimary: false,
        isProvider: true,
        check: false,
        roleid: null,
      };
      this.$emit('update-signatures-provider', [newSignature]);
    },
  },
};
</script>
<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';
.result-table {
  padding-left: 20px;
  background-color: #f7f7f7;
  border-bottom: 1px solid darkgray;
}
.row-message {
  border: 1px solid #f3af54;
  margin-bottom: 0px !important;
}
</style>
